export const styles = {
	field: {
		marginBottom: '8px',
		width: 400,
		display: 'flex'
	},
	container: {
		padding: 0,
		'& .MuiGrid-item': {
			padding: 0
		}
	},
	error: {
		color: 'red',
		marginTop: '8px',
		marginLeft: '8px'
	},
	cardError: {
		color: '#CC0023',
		border: '1px solid',
		padding: '11px',
		marginBottom: '11px',
		borderRadius: 5
	}
};
